import { buildProperty, buildCollection, EntityReference } from "@firecms/core";
import enumLocales from "./locales.enum";

interface IReview {
  courses: EntityReference[];
  custom_offers: EntityReference[];
  rating: number;
  date: Date;
  active: boolean;
  priority: number;
  avatar: string;
}

const ReviewLocaleSchema = buildCollection({
  id: "review_locales",
  name: "Locale",
  path: "locales",
  customId: enumLocales,
  properties: {
    name: buildProperty({
      name: "Name",
      dataType: "string",
      columnWidth: 400,
      validation: { required: true },
    }),
    location: buildProperty({
      name: "Location",
      dataType: "string",
      columnWidth: 400,
    }),
    text: buildProperty({
      name: "Review text",
      dataType: "string",
      columnWidth: 400,
      markdown: true,
      validation: { required: true },
    }),
  },
});

const ReviewSchema = buildCollection<IReview>({
  id: "reviews",
  name: "Reviews",
  path: "reviews",
  subcollections: [ReviewLocaleSchema],
  properties: {
    courses: buildProperty({
      name: "Courses",
      description: "Link one or more experiences to this review",
      dataType: "array",
      columnWidth: 400,
      of: {
        dataType: "reference",
        path: "courses",
        previewProperties: ["custom_id"],
      },
    }),
    custom_offers: buildProperty({
      name: "Custom Offers",
      description: "Link one or more custom offers (transportation, accommodation, etc.) to this review",
      dataType: "array",
      columnWidth: 400,
      of: {
        dataType: "reference",
        path: "custom_offers",
        previewProperties: ["custom_id"],
      },
    }),
    rating: buildProperty({
      name: "Rating",
      dataType: "number",
      defaultValue: 5,
      validation: { min: 1, max: 5 },
    }),
    date: buildProperty({
      name: "Date",
      dataType: "date",
      mode: "date",
      validation: { required: true },
    }),
    active: buildProperty({
      name: "Active",
      dataType: "boolean",
      defaultValue: true,
    }),
    priority: buildProperty({
      name: "Priority",
      dataType: "number",
      defaultValue: 0,
    }),
    avatar: buildProperty({
      name: "Avatar initials",
      description: "Optional override (e.g. CC). Leave empty to derive from name.",
      dataType: "string",
    }),
  },
});

export default ReviewSchema;
export { ReviewLocaleSchema };
